function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 25.5,
  r: 25.5,
  fill: "#F9C646"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_107_215)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5 19.5599C16.5 19.5599 17.6363 22.4261 20.5 27.8676C20.5 27.8676 20.5 27.8676 20.5 27.9092C23.4091 33.3507 25.2727 35.8015 25.2727 35.8015C27.1818 37.6707 30.3636 38.5015 33.7727 37.0061C35.6363 36.1753 35.3182 34.223 33.5909 30.983C32.0454 28.0753 30.3182 27.9923 29.1818 28.9061C28.9545 29.0723 28.2272 29.6953 28.1818 29.903C28.1818 29.903 27.5 30.9415 24.9091 25.9984C22.3182 21.0969 23.3636 21.3461 23.3636 21.3461C23.5454 21.3876 24.5454 21.5123 24.8182 21.4292C26.2727 21.1384 27.4545 19.7261 25.7727 16.5692C24.0454 13.3292 22.5909 11.8753 20.7272 12.7061C17.9091 13.9107 16.0909 17.0261 16.5 19.5599Z",
  stroke: "white",
  strokeWidth: 2
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_107_215"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 27,
  fill: "white",
  transform: "translate(16 12)"
})));

function SvgContacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.4d78dab94e44973ae9faf079a8a12922.svg";
export { ForwardRef as ReactComponent };